import en from './en';
import { msFullPatch } from './msFullPatch';

const ms = {
  ...en,
  ...msFullPatch,
  lang: 'ms',
  langName: 'Bahasa Melayu',
  flag: '🇲🇾',
  siteTitle: 'Ujian Mock TOEFL iBT Percuma - Analisis AI | Power TOEFL 2026',
  siteDescription: 'Latih ujian mock TOEFL 2026 secara percuma. Analisis AI Reading, Listening, Bertutur, Penulisan, semakan kesilapan, dan penukaran skor.',
  ogTitle: 'Ujian Mock TOEFL iBT Percuma - Analisis AI | Power TOEFL 2026',

  navGrammar: 'Tatabahasa',
  navPractice: 'Latihan Seksyen',
  navScoreChart: 'Carta Skor',
  navVocabulary: 'Kosa Kata',
  navTips: 'Tip & Strategi',
  navQuestionPool: 'Bank Soalan',
  navResources: 'Sumber',
  navSpeaking: 'Bertutur',
  navWriting: 'Penulisan',
  navPremium: 'Pelan Pro',

  loginButton: 'Log masuk',
  wrongAnswers: 'Nota Kesilapan',
  logout: 'Log keluar',
  loginRequired: 'Log masuk diperlukan untuk Nota Kesilapan dan sambung ujian.',
  googleLogin: 'Teruskan dengan Google untuk ciri premium',

  heroBadge: 'Sistem Pembelajaran TOEFL Premium',
  heroTitle1: 'Satu Platform',
  heroTitle2: 'untuk Skor TOEFL Tinggi',
  heroDesc1: 'Daripada ujian mock penuh 4 seksyen hingga semakan kesilapan peribadi,',
  heroDesc2: 'semua yang anda perlukan untuk capai skor sasaran.',

  lcSubtitle: 'Reading - 20 soalan',
  lcTime: '35 min',
  rcSubtitle: 'Listening - 28 soalan',
  rcTime: '36 min',
  startTest: 'Mula Ujian',
  fullTestStart: 'Mula Ujian Mock Penuh (Reading -> Listening)',
  fullTestDesc: 'Selesaikan kedua-dua seksyen secara berurutan',

  moreTools: 'Lebih Banyak Alat Pembelajaran',
  practiceLabel: 'Latihan Seksyen',
  practiceDesc: 'Latih Reading dan Listening secara berasingan',
  scoreChartLabel: 'Penukaran Skor',
  scoreChartDesc: 'Bilangan betul kepada skor anggaran',
  vocabDesc: 'Kosa kata TOEFL penting',
  tipsDesc: 'Strategi Listening dan Reading',
  catDesc: 'Kesukaran dilaras automatik ikut tahap anda',
  guideLabel: 'Panduan Belajar',
  guideDesc: 'Strategi ikut kemahiran, pelan ikut skor, dan perbandingan ujian',
  fullTestCardLabel: 'Ujian Mock Penuh',
  fullTestCardDesc: 'Latihan Reading + Listening seperti sebenar',
  grammarSectionTitle: 'Buku Tatabahasa Inggeris',
  grammarSectionDesc: 'Kuasai tatabahasa TOEFL secara berstruktur',
  grammarViewAll: 'Lihat semua',
  proBadgeLabel: 'Pro',

  statQuestions: 'Soalan',
  statParts: 'Bahagian',
  statMinutes: 'Minit',

  footerMockTest: 'Latihan',
  footerQuestionPool: 'Bank Soalan',
  footerPractice: 'Latihan Seksyen',
  footerStudy: 'Belajar',
  footerBooks: 'Buku Disyorkan',
  footerEtc: 'Lain-lain',
  footerLC: 'Latihan Listening',
  footerRC: 'Latihan Reading',
  footerSpeaking: 'Latihan Bertutur',
  footerWriting: 'Latihan Penulisan',
  footerLCStrategy: 'Strategi Listening',
  footerRCStrategy: 'Strategi Reading',

  faqTitle: 'Soalan Lazim',
  faqDesc: 'Lihat jawapan tentang TOEFL dan Power TOEFL.',
  faqMore: 'Perlukan bantuan lanjut? FAQ ini sentiasa dikemas kini.',

  tipsLCPageTitle: 'Cara Tingkatkan Skor TOEFL Listening | Rutin Latihan LC - Power TOEFL',
  tipsLCPageDesc: 'Latihan praktikal TOEFL Listening untuk meningkatkan skor LC: note-taking bagi Conversations dan Lectures, inferens, dan soalan sikap penutur.',
  tipsLCHeading: 'Strategi Skor TOEFL Listening',
  tipsLCIntro: 'Strategi utama dan rutin praktikal untuk setiap bahagian TOEFL Listening.',
  tipsLCPractice: 'Latih Listening Sekarang',
  tipsLCPracticeDesc: 'Gunakan strategi ini dalam ujian latihan sebenar.',
  tipsLCStartTest: 'Mula Ujian Listening',
  tipsRCPageTitle: 'Strategi TOEFL Reading - Panduan Teks Akademik | Power TOEFL',
  tipsRCPageDesc: 'Strategi TOEFL Reading untuk teks akademik: agihan masa, inferens, dan cara jawab soalan ringkasan.',
  tipsRCHeading: 'Strategi TOEFL Reading',
  tipsRCIntro: 'Panduan praktikal strategi bacaan dan pengurusan masa TOEFL Reading.',
  tipsRCPractice: 'Latih Reading Sekarang',
  tipsRCPracticeDesc: 'Gunakan strategi ini dalam ujian latihan sebenar.',
  tipsRCStartTest: 'Mula Ujian Reading',
  tips7DayTitle: 'Pelan Belajar 7 Hari Saat Akhir',
  tips7DayDesc: 'Maksimumkan skor dengan rutin minggu akhir yang fokus',
  tipsTrapTitle: 'Panduan Corak Perangkap',
  tipsTrapDesc: 'Kenali 5 corak perangkap paling biasa lebih awal',

  aboutPageTitle: 'Tentang Power TOEFL - Simulasi Percuma dan Alat Pembelajaran AI',
  aboutPageDesc: 'Berlatih TOEFL dengan simulasi penuh, analisis kelemahan AI, dan ulang kaji automatik soalan salah.',
  aboutHeading: 'Power TOEFL - Platform Persediaan TOEFL Praktikal',
  aboutS1Title: 'Apa itu Power TOEFL?',
  aboutS1Body: 'Power TOEFL ialah platform pembelajaran dalam talian percuma untuk calon TOEFL. Kami menyediakan simulasi penuh, latihan jana AI, dan alat semakan kesilapan.',
  aboutS2Title: 'Sesuai untuk siapa?',
  aboutS2Body: 'Sesuai untuk pelajar, profesional, dan calon pembelajaran kendiri yang mahukan latihan berstruktur untuk capai skor sasaran.',
  aboutS3Title: 'Ciri Utama',
  aboutFeature1: 'Simulasi penuh gaya TOEFL dengan pelbagai pusingan',
  aboutFeature2: 'Latihan fokus Reading, Listening, Speaking dan Writing',
  aboutFeature3: 'Penjanaan soalan berasaskan AI dan analisis kelemahan',
  aboutFeature4: 'Nota kesilapan automatik dengan ulang kaji berjarak',
  aboutFeature5: 'Carta penukaran skor dan kosa kata TOEFL penting',
  aboutS4Title: 'Free vs Premium',
  aboutS4Body: 'Free merangkumi simulasi, latihan seksyen dan carta skor. Premium menambah penjanaan AI tanpa had, tanpa iklan, dan akses penuh simulasi.',
  aboutS5Title: 'Mengapa skor meningkat',
  aboutS5Body: 'Dengan ulang kaji berjarak, analisis kelemahan yang tepat, dan suasana latihan realistik, kemahiran ujian akan meningkat secara konsisten.',
  aboutS6Title: 'Hubungan dengan ETS',
  aboutS6Body: 'Power TOEFL ialah platform bebas dan tidak berafiliasi atau disokong oleh ETS. TOEFL ialah tanda dagangan berdaftar ETS.',
  aboutS7Title: 'Hubungi',
  aboutS7Body: 'Untuk pertanyaan perkhidmatan, hubungi skdaks0731@gmail.com.',
  aboutCtaHeading: 'Mulakan hari ini',
  aboutCtaDesc: 'Cuba ujian latihan TOEFL percuma sekarang.',
  aboutCtaStart: 'Mula ujian mock',
  aboutCtaPricing: 'Lihat Pelan Premium',

  catPageTitle: 'TOEFL Adaptive Test (CAT) - Tahap Kesukaran Auto oleh AI | Power TOEFL',
  catPageDesc: 'Ujian latihan adaptif TOEFL. AI melaras tahap kesukaran soalan secara automatik berdasarkan prestasi anda.',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'Kesukaran dilaras mengikut ketepatan anda. {count} soalan setiap sesi.',
  catNote: "ℹ️ Nota: TOEFL iBT sebenar ialah ujian linear (bukan adaptif). Practice CAT ini ialah alat belajar yang melaraskan kesukaran mengikut prestasi anda supaya cepat mengetahui tahap anda — ia bukan simulasi format peperiksaan sebenar.",
  catSelectSection: 'Pilih Seksyen',
  catStartBtn: 'Mula Adaptive Test',
  catLoading: 'Memuatkan soalan seterusnya...',
  catNoMore: 'Tiada lagi soalan tersedia',
  catComplete: 'Adaptive Test Selesai',
  catAccuracy: 'Ketepatan',
  catFinalLevel: 'Tahap akhir',
  catTryAgain: 'Cuba Lagi',
  catViewResults: 'Lihat Keputusan',
  catNext: 'Seterusnya',
  catExplanation: 'Penjelasan',
  catStop: 'Henti',
  catPlayAudio: 'Main Audio',
  catReadingPassage: 'Petikan Reading',

  scoreChartHeading: 'Carta Penukaran Skor TOEFL',
  scoreChartIntro: 'Jadual seksyen 0–30 dan jumlah 0–120 ialah anggaran pembelajaran Power TOEFL pada skala lama/boleh dibandingkan. Laporan rasmi 2026 mengutamakan skor seksyen dan keseluruhan 1–6 dalam kenaikan 0.5.',
  scoreChartLC: 'Penukaran Reading',
  scoreChartRC: 'Penukaran Listening',
  scoreChartCorrect: 'Betul',
  scoreChartConverted: 'Skor Penukaran',
  scoreChartPointUnit: 'mata',
  scoreGuideTitle: 'Panduan Skor Sasaran',
  scoreGuide900: 'Tahap Tertinggi',
  scoreGuide900Desc: 'Sasar 28+ setiap seksyen. Kukuh untuk kemasukan universiti teratas.',
  scoreGuide800: 'Tahap Atas',
  scoreGuide800Desc: 'Sasar 22+ setiap seksyen. Memenuhi kebanyakan syarat kemasukan.',
  scoreGuide700: 'Pertengahan Tinggi',
  scoreGuide700Desc: 'Asas akademik dicapai. Kemasukan bersyarat mungkin.',
  scoreGuide600: 'Pertengahan',
  scoreGuide600Desc: 'Fokus kepada asas Reading dan Listening terlebih dahulu.',
  scoreGuideDescs: [
    'Disyorkan Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+. Kuat untuk kemasukan universiti teratas.',
    'Sasar Reading 22+ / Listening 22+. Memenuhi kebanyakan syarat kemasukan.',
    'Asas akademik dicapai. Kemasukan bersyarat mungkin dengan latihan fokus.',
    'Peringkat asas. Utamakan asas Reading dan Listening dahulu.',
  ],
  scoreChartFaqTitle: 'FAQ Skor TOEFL',
  scoreChartCtaTitle: 'Semak tahap anda sekarang',
  scoreChartCtaDesc: 'Ambil ujian mock TOEFL percuma dan anggar skor anda.',
  scoreReadingHeader: 'Reading (0-30 mata)',
  scoreListeningHeader: 'Listening (0-30 mata)',
  scoreSpeakingHeader: 'Bertutur (0-30 mata)',
  scoreWritingHeader: 'Penulisan (0-30 mata)',
  scoreSpeakingDesc: '4 tugasan dinilai pada skala 0-4, kemudian ditukar kepada 30 mata',
  scoreWritingDesc: '2 tugasan dinilai pada skala 0-5, kemudian ditukar kepada 30 mata',
  scoreSpeakingLevels: [
    ['4 (Baik)', '27-30 mata', 'Jawapan lancar, tepat dan tersusun logik'],
    ['3 (Memadai)', '19-26 mata', 'Kebanyakannya jelas tetapi ada beberapa kesilapan'],
    ['2 (Terhad)', '11-18 mata', 'Komunikasi asas boleh dibuat tetapi terhad'],
    ['1 (Lemah)', '1-10 mata', 'Maksud sukar disampaikan'],
  ],
  scoreWritingLevels: [
    ['5 (Baik)', '27-30 mata', 'Esei logik dan terperinci dengan tatabahasa tepat'],
    ['4 (Memadai)', '22-26 mata', 'Secara keseluruhan baik tetapi sebahagian kurang berkembang'],
    ['3 (Terhad)', '15-21 mata', 'Ada struktur asas tetapi huraian lemah'],
    ['2 (Lemah)', '8-14 mata', 'Ada bahagian tersasar atau struktur tidak jelas'],
    ['1 (Sangat Lemah)', '1-7 mata', 'Hampir tiada penyampaian makna yang jelas'],
  ],

  vocabHeading: 'Kosa Kata TOEFL Penting',
  vocabIntro: 'Belajar kosa kata penting ikut kategori. Klik untuk lihat maksud.',
  vocabShowAll: 'Tunjuk semua',
  vocabHideAll: 'Sembunyi semua',
  vocabReset: 'Set semula',
  vocabClickToReveal: 'Klik untuk lihat maksud',
  vocabMotivation: 'Ulang kaji konsisten membantu menaikkan skor TOEFL.',
  vocabMyWords: 'Kosa Kata Saya',
  vocabAddWord: 'Tambah Perkataan',
  vocabAddWordPlaceholder: 'Masukkan perkataan Inggeris',
  vocabMyWordsEmpty: 'Belum ada perkataan ditambah. Tambah perkataan pertama anda.',
  vocabDeleteWord: 'Padam',
  vocabLookingUp: 'Mencari...',
  vocabQuizTitle: 'Kuiz Kosa Kata',
  vocabQuizDesc: 'Uji sinonim dan antonim perkataan yang dipelajari.',
  vocabQuizMode_synonym: 'Kuiz Sinonim',
  vocabQuizMode_antonym: 'Kuiz Antonim',
  vocabQuizMode_mixed: 'Kuiz Campuran',
  vocabQuizClose: 'Tutup',
  vocabQuizNoQuestions: 'Soalan kuiz belum mencukupi dalam kategori ini.',
  vocabQuizBack: 'Kembali',
  vocabQuizResult: 'Keputusan Kuiz',
  vocabQuizExcellent: 'Cemerlang!',
  vocabQuizGood: 'Bagus. Sedikit lagi latihan dan anda mantap.',
  vocabQuizKeepGoing: 'Teruskan!',
  vocabQuizRetry: 'Cuba semula',
  vocabQuizFindSynonym: 'Pilih sinonim bagi perkataan berikut',
  vocabQuizFindAntonym: 'Pilih antonim bagi perkataan berikut',
  vocabQuizNext: 'Seterusnya',
  vocabQuizFinish: 'Lihat Keputusan',
  vocabQuizStart: 'Mula Kuiz',

  testPrevious: 'Sebelum',
  testNext: 'Seterusnya',
  testQuestion: 'Soalan',
  testQuestionPrompt: 'Baca soalan dan pilih jawapan terbaik.',
  testMarkAnswer: 'Sila tandakan nombor jawapan terbaik.',
  testSelect: 'Pilih',
  testShowAnswer: 'Lihat jawapan dan penjelasan',
  testCorrect: 'Betul!',
  testIncorrect: 'Salah.',
  testSubmit: 'Hantar Ujian',
  testContinue: 'Teruskan',

  resultsTitle: 'Keputusan Ujian {0}',
  resultsTimeUsed: 'Masa digunakan: {0}m {1}s',
  resultsEstimatedScore: 'Skor anggaran (daripada 30)',
  resultsCorrect: 'Betul',
  resultsIncorrect: 'Salah',

  navHome: 'Laman Utama',
  navReading: 'Reading',
  navListening: 'Listening',
  roundDetailHeading: 'Simulasi TOEFL Penuh',
  roundDetailOtherRounds: 'Lihat pusingan lain',
  roundLabel: 'Pusingan',
  roundSuffix: '',
  pricingTitle: 'Harga Power TOEFL Pro — RM39/bulan | Percuma vs Pro | 2026',
  pricingDesc: 'Banding pelan percuma dan Pro: AI tanpa had, tanpa iklan, semua pusingan simulasi.',
  statsTitle: 'Statistik Pembelajaran TOEFL — Power TOEFL',
  statsDesc: 'Lihat statistik kuiz tatabahasa, nota kesilapan, dan kemajuan anda.',
  statsH1: '📊 Statistik Pembelajaran',
} as typeof en;

export default ms;
